var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { forwardRef, useEffect, useState, } from 'react';
import styled from 'styled-components';
import { Select, get } from '@ally/metronome-ui';
import { getAccountLabel, getNormalizedAccountStatus } from '../utils';
var StyledAccountSelector = styled(Select)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  height: auto;\n  text-align: center;\n  width: 100%;\n\n  &::before {\n    content: none;\n  }\n\n  select {\n    font-size: ", ";\n    font-weight: bold;\n    font-family: ", ";\n    height: ", ";\n    margin: 0;\n    padding-left: 21px;\n    padding-right: ", ";\n    width: 100%;\n    border-color: ", ";\n\n    &:focus {\n      background: ", ";\n    }\n\n    &[disabled] {\n      /**\n      * the user agent stylesheet opacity value is 0.7. This makes the select a\n      * different color than the display tile that overlays it. Setting opacity\n      * to 1 fixes the issue.\n      */\n      opacity: 1;\n    }\n\n    &::-ms-expand {\n      display: none;\n    }\n  }\n\n  &[disabled] {\n    svg {\n      display: none;\n    }\n\n    ::before {\n      display: none;\n    }\n  }\n"], ["\n  font-size: ", ";\n  height: auto;\n  text-align: center;\n  width: 100%;\n\n  &::before {\n    content: none;\n  }\n\n  select {\n    font-size: ", ";\n    font-weight: bold;\n    font-family: ", ";\n    height: ", ";\n    margin: 0;\n    padding-left: 21px;\n    padding-right: ", ";\n    width: 100%;\n    border-color: ",
    ";\n\n    &:focus {\n      background: ", ";\n    }\n\n    &[disabled] {\n      /**\n      * the user agent stylesheet opacity value is 0.7. This makes the select a\n      * different color than the display tile that overlays it. Setting opacity\n      * to 1 fixes the issue.\n      */\n      opacity: 1;\n    }\n\n    &::-ms-expand {\n      display: none;\n    }\n  }\n\n  &[disabled] {\n    svg {\n      display: none;\n    }\n\n    ::before {\n      display: none;\n    }\n  }\n"])), get.fontSizes('md'), get.fontSizes('sm'), function (_a) {
    var theme = _a.theme;
    return theme.fonts.regular;
}, get.space('xxl'), get.space('xxl'), function (props) {
    return props.errorMessage
        ? "" + props.theme.colors.error
        : "" + props.theme.colors['slate-3'];
}, get.colors('white'));
var AccountSelector = forwardRef(function (_a, ref) {
    var id = _a.id, className = _a.className, accounts = _a.accounts, prompt = _a.prompt, terminal = _a.terminal, value = _a.value, disabled = _a.disabled, error = _a.error, required = _a.required, ariaRequired = _a.ariaRequired, ariaDescribedby = _a.ariaDescribedby, ariaLabelledby = _a.ariaLabelledby, onAccountSelect = _a.onAccountSelect, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var _b = useState([]), groupedAccounts = _b[0], setGroupedAccounts = _b[1];
    function buildAccountOption(account) {
        var accountId = account.accountId, status = account.status, isIneligible = account.isIneligible;
        var normalizedStatus = getNormalizedAccountStatus(status);
        var includeStatus = !['active', 'open'].includes(normalizedStatus);
        var label = getAccountLabel(account, false, includeStatus);
        return {
            label: label,
            disabled: isIneligible,
            value: accountId,
        };
    }
    useEffect(function () {
        var totalAccounts = accounts.length;
        if (totalAccounts > 0) {
            // INTERNAL ACCOUNTS
            var internalAccountOptions = accounts
                .filter(function (_a) {
                var group = _a.group;
                return ['internal', 'ira'].includes(group);
            })
                .map(buildAccountOption);
            var internalAccountsCount = internalAccountOptions.length;
            // EXTERNAL ACCOUNTS
            var externalAccountOptions = [];
            if (internalAccountsCount < totalAccounts) {
                externalAccountOptions = accounts
                    .filter(function (_a) {
                    var group = _a.group;
                    return group === 'external';
                })
                    .map(buildAccountOption);
            }
            var externalAccountsCount = externalAccountOptions.length;
            // INVEST ACCOUNTS
            var investAccountOptions = [];
            if (internalAccountsCount + externalAccountsCount < totalAccounts) {
                investAccountOptions = accounts
                    .filter(function (_a) {
                    var group = _a.group;
                    return group === 'invest';
                })
                    .map(buildAccountOption);
            }
            var groupedAccountOptions = [];
            if (prompt) {
                groupedAccountOptions.push({
                    label: prompt,
                    value: '',
                });
            }
            if (internalAccountsCount) {
                groupedAccountOptions.push({
                    label: 'Ally Bank Accounts',
                    options: internalAccountOptions,
                });
            }
            if (investAccountOptions.length) {
                groupedAccountOptions.push({
                    label: 'Ally Invest Accounts',
                    options: investAccountOptions,
                });
            }
            if (externalAccountsCount) {
                groupedAccountOptions.push({
                    label: 'Accounts At Other Institutions',
                    options: externalAccountOptions,
                });
            }
            if (terminal) {
                groupedAccountOptions.push({
                    label: terminal,
                    value: terminal,
                });
            }
            setGroupedAccounts(groupedAccountOptions);
        }
    }, [accounts, prompt, terminal]);
    return (React.createElement(StyledAccountSelector, { ref: ref, id: id, className: className, options: groupedAccounts, onChange: onAccountSelect, onFocus: onFocus, onBlur: onBlur, value: value, disabled: disabled, required: required, 
        // Using different error prop to avoid Select's default error style
        errorMessage: error, ariaRequired: ariaRequired, ariaLabelledby: ariaLabelledby, ariaDescribedby: ariaDescribedby, "data-allytm-error": error, "data-allytmfn": id }));
});
export default AccountSelector;
var templateObject_1;
//# sourceMappingURL=AccountSelector.js.map